export default __webpack_public_path__ + "static/media/inessa-miller.81c193ec.png";